export default "__VITE_ASSET__BG8eYXrT__"